import { MeshBasicMaterial, ShaderMaterial, Uniform, DoubleSide } from 'three' 
import {videoTvTexture} from '../data/videoTexture'
import smokeVertexShader from '../shader/coffeSmoke/vertex.glsl'
import smokeFragmentShader from '../shader/coffeSmoke/fragment.glsl'



export const createMaterials = (groupDefault)=>{
    const smokeMaterial = new ShaderMaterial({
        vertexShader: smokeVertexShader, 
        fragmentShader: smokeFragmentShader,
            uniforms: {
                uTime: {value: 0},
                uPerlintexture: new Uniform(groupDefault.perlinTexture)
            },
            transparent:true,
            side: DoubleSide,
            depthWrite: false
    })
    
    const baseMaterials = {
        groupOne: new MeshBasicMaterial({map: groupDefault.groupOneDefault}),
        groupTwo: new MeshBasicMaterial({map: groupDefault.groupTwoDefault}),
        groupThree: new MeshBasicMaterial({map: groupDefault.groupThreeDefault}),
        groupFour: new MeshBasicMaterial({map: groupDefault.groupFourDefault}),
        lights: new MeshBasicMaterial({ color: '#F5EBBF'}), 
        groupFive: new MeshBasicMaterial({map: groupDefault.groupFiveDefault, alphaTest: 0.5}),
        screenTv: new MeshBasicMaterial({map: videoTvTexture}),
        bubbles: new MeshBasicMaterial({map: groupDefault.groupBubblesDefault, transparent: true}),
        squares: new MeshBasicMaterial({color: '#F5EBBF', transparent: true}),
       smoke: smokeMaterial,
    }
    return {
        ...baseMaterials, 
        drawer: baseMaterials.groupThree,
        board: baseMaterials.groupThree,
        bigBubbleProjects: baseMaterials.bubbles,
        bigBubbleAbout: baseMaterials.bubbles,
        smallBubbleTv: baseMaterials.bubbles,
        smallBubbleMountain: baseMaterials.bubbles,
        smallBubbleSkull: baseMaterials.bubbles,
        skull: baseMaterials.groupThree, 
        mountain: baseMaterials.groupThree,
        radio: baseMaterials.groupThree,
        picture: baseMaterials.groupFive
    }
}

